import { useState } from "react";
import Preloader from "@/components/feature/Preloader";
import Navbar from "@/components/feature/Navbar";
import HeroSection from "@/components/feature/HeroSection";
import AdvantagesSection from "@/components/feature/AdvantagesSection";
import PartnersSection from "@/components/feature/PartnersSection";
import CasesSection from "@/components/feature/CasesSection";
import PricingSection from "@/components/feature/PricingSection";
import FaqSection from "@/components/feature/FaqSection";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";

export default function Home() {
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading && <Preloader onComplete={() => setLoading(false)} />}
      <div className={loading ? "opacity-0" : "opacity-100 transition-opacity duration-500"}>
        <Navbar />
        <ScrollToTop />
        <main>
          <HeroSection />
          <AdvantagesSection />
          <PartnersSection />
          <CasesSection />
          <PricingSection />
          <FaqSection />
        </main>
        <Footer />
      </div>
    </>
  );
}